import React, { useState } from "react";
import axios from "axios";
import "../css/ContactForm.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    category: "Suggestion",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = "Name is required";
    if (!formData.email.trim()) {
      errs.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        errs.email = "Invalid email address";
      }
    }
    if (!formData.message.trim() || formData.message.trim().length < 10) {
      errs.message = "Message must be at least 10 characters";
    }
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);

    try {
      // Axios already has baseURL + withCredentials set in index.js
      await axios.post("/api/contactform/", formData);

      setIsSubmitted(true);
      setFormData({
        name: "",
        email: "",
        category: "Suggestion",
        message: ""
      });
      setErrors({});
    } catch (error) {
      if (error.response?.data?.message) {
        setErrorMessage(error.response.data.message);
      } else if (error.response?.data?.detail) {
        setErrorMessage(error.response.data.detail);
      } else {
        setErrorMessage("Oops! Something went wrong. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="contact-form" style={{ textAlign: "center", padding: "40px" }}>
        <h2>🎉 Thank you!</h2>
        <p>Your message has been submitted to the TefDB team.</p>
        <button onClick={() => setIsSubmitted(false)} style={{ marginTop: "20px" }}>
          Send Another Message
        </button>
      </div>
    );
  }

  return (
    <div className="contact-form" role="form" aria-label="Contact EragroBase Team">
      <h2>Contact TefDB Team</h2>
      <p style={{ textAlign: "center", marginBottom: "20px", color: "#555" }}>
        Send us your <strong>suggestions</strong> or ask <strong>platform-related questions</strong>.
      </p>

      {errorMessage && <p className="error" role="alert">{errorMessage}</p>}

      <form onSubmit={handleSubmit} noValidate>
        <div className="form-group">
          <label htmlFor="name">Your Name<span aria-hidden="true" style={{color:"red"}}> *</span></label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your full name"
            value={formData.name}
            onChange={handleChange}
            aria-invalid={errors.name ? "true" : "false"}
            aria-describedby="name-error"
            required
            disabled={isSubmitting}
          />
          {errors.name && <span id="name-error" className="error">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Your Email<span aria-hidden="true" style={{color:"red"}}> *</span></label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="example@domain.com"
            value={formData.email}
            onChange={handleChange}
            aria-invalid={errors.email ? "true" : "false"}
            aria-describedby="email-error"
            required
            disabled={isSubmitting}
          />
          {errors.email && <span id="email-error" className="error">{errors.email}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="category">Message Type</label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            disabled={isSubmitting}
          >
            <option value="Suggestion">Suggestion</option>
            <option value="Question">Question</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="message">Your Message<span aria-hidden="true" style={{color:"red"}}> *</span></label>
          <textarea
            id="message"
            name="message"
            placeholder="Let us know your feedback or ask a question about the platform..."
            value={formData.message}
            onChange={handleChange}
            aria-invalid={errors.message ? "true" : "false"}
            aria-describedby="message-error"
            required
            disabled={isSubmitting}
          />
          {errors.message && <span id="message-error" className="error">{errors.message}</span>}
        </div>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Submit Message"}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;

